import React from "react"
import Icon from "@ant-design/icons"

const TwitterSVG = () => (
  <svg
    width="18"
    height="21"
    viewBox="0 0 18 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.1367 6.59375C16.8398 6.06641 17.4727 5.43359 17.9648 4.69531C17.332 4.97656 16.5938 5.1875 15.8555 5.25781C16.6289 4.80078 17.1914 4.09766 17.4727 3.21875C16.7695 3.64062 15.9609 3.95703 15.1523 4.13281C14.4492 3.39453 13.5 2.97266 12.4453 2.97266C10.4062 2.97266 8.75391 4.625 8.75391 6.66406C8.75391 6.94531 8.78906 7.22656 8.85938 7.50781C5.80078 7.33203 3.05859 5.85547 1.23047 3.64062C0.914062 4.16797 0.738281 4.80078 0.738281 5.50391C0.738281 6.76953 1.37109 7.89453 2.39062 8.5625C1.79297 8.52734 1.19531 8.38672 0.703125 8.10547V8.14062C0.703125 9.93359 1.96875 11.4102 3.65625 11.7617C3.375 11.832 3.02344 11.9023 2.70703 11.9023C2.46094 11.9023 2.25 11.8672 2.00391 11.832C2.46094 13.3086 3.83203 14.3633 5.44922 14.3984C4.18359 15.3828 2.60156 15.9805 0.878906 15.9805C0.5625 15.9805 0.28125 15.9453 0 15.9102C1.61719 16.9648 3.55078 17.5625 5.66016 17.5625C12.4453 17.5625 16.1367 11.9727 16.1367 7.08594C16.1367 6.91016 16.1367 6.76953 16.1367 6.59375Z"
      fill="#FF6900"
    />
  </svg>
)

const Twitter = props => <Icon component={TwitterSVG} {...props} />

export default Twitter
